import { useEffect, useState } from "react";
import { fetchTeamsForPlan } from "./coachOnboardingServices";
import { dataStatusNotice, teamsDataStatus } from "../../../ForBusiness/Cacheshare/allocationModel";

// The teams a fetch plan lists, loaded while the Team step is open. The
// "Any league" plan changes with every letter typed, so it waits a moment.
// throwOnError asks the fetch to report a source that fails to answer (for
// a union of sources, such as a skipped College league, when none answers),
// so the step shows an error with Retry instead of an empty scope that would
// send the coach to "Can't find team" for a team that exists. allTeams: the
// coach binds a team here rather than scoring it, so a football team with no
// saved stats stays pickable while its provider is paused. `notice` says
// when a list came back limited (the team feed answered in part, or only
// the teams already on CACHE or a saved list stand in), in CACHE's words.
const NAME_SEARCH_DELAY_MS = 300;
const FETCH_OPTIONS = { throwOnError: true, allTeams: true };
const IDLE = { teams: [], loading: false, error: "", notice: "" };

export const useTeamOptions = (plan) => {
  const [result, setResult] = useState(IDLE);
  const [attempt, setAttempt] = useState(0);
  const key = plan ? JSON.stringify(plan) : "";

  useEffect(() => {
    if (!plan) {
      setResult(IDLE);
      return undefined;
    }
    let live = true;
    setResult((r) => ({ ...r, loading: true, error: "" }));
    const timer = setTimeout(() => {
      fetchTeamsForPlan(plan, FETCH_OPTIONS)
        .then((teams) => live && setResult({ teams: teams || [], loading: false, error: "", notice: dataStatusNotice(teamsDataStatus(teams)) }))
        .catch(() => live && setResult({ teams: [], loading: false, error: "We could not load teams. Try again.", notice: "" }));
    }, plan.anyLeague ? NAME_SEARCH_DELAY_MS : 0);
    return () => {
      live = false;
      clearTimeout(timer);
    };
    // The plan is a new object every render; `key` is its content.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, attempt]);

  return { ...result, retry: () => setAttempt((n) => n + 1) };
};
